import type { BudgetLevel, HalalStatus, Shop } from "../types";

export interface FoodPickerFilters {
  halal: "any" | HalalStatus;
  cuisine: string;
  budget: "any" | BudgetLevel;
  floor: "any" | string;
}

export function filterFoodShops(shops: Shop[], filters: FoodPickerFilters): Shop[] {
  return shops.filter((shop) => {
    if (!shop.categoryIds.includes("food-beverage")) return false;
    if (filters.halal !== "any" && shop.halalStatus !== filters.halal) return false;
    if (filters.cuisine !== "any" && !shop.cuisineTypes.includes(filters.cuisine)) return false;
    if (filters.budget !== "any" && shop.budgetLevel !== filters.budget) return false;
    if (filters.floor !== "any" && shop.floor !== filters.floor) return false;
    return true;
  });
}

export function pickRandomFood(shops: Shop[], previousShopId: string | null = null): Shop | null {
  if (shops.length === 0) return null;
  const candidates =
    shops.length > 1 && previousShopId ? shops.filter((shop) => shop.id !== previousShopId) : shops;
  const index = Math.floor(Math.random() * candidates.length);
  return candidates[index] ?? null;
}

export function uniqueCuisines(shops: Shop[]): string[] {
  return Array.from(new Set(shops.flatMap((shop) => shop.cuisineTypes))).sort();
}

